// index.js
import React from 'react'
import { HashRouter, Routes, Route } from 'react-router-dom'
import App from './App'
import Register from './components/Register'
import PrivacyPolicy from './components/PrivacyPolicy'

import ReactDOM from 'react-dom/client'
import { AppProvider } from './context/AppContext'
// Import language context
import { LanguageProvider } from './context/LanguageContext'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <AppProvider>
      <LanguageProvider>
        <HashRouter>
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/register" element={<Register />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </HashRouter>
      </LanguageProvider>
    </AppProvider>
  </React.StrictMode>
)
